import React, { useState, useEffect, useContext } from 'react'
import AdminContext from '../../StateContext/Application'
import { apiurl } from '../../../../path'
// import { Time32,UpdateWhite32,Excel32,JPG32,PNG32,AddFile32, VendorName32, Bank32, barely_black_bg_img, Cancel32, Email32, Location32, PhoneNumber32, submit } from "../../../../../public/LoginImages/importimages";

const BudgetEstimationList = () => {
    const context = useContext(AdminContext)
    const { GetAllBudgetEstimationList } = context
    const [budgetEstimation, setBudgetEstimationList] = useState([])
    const [filteredBills, setFilteredBills] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const billsPerPage = 10;
    const [searchTerm, setSearchTerm] = useState('');

    const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
    const indexOfLastBill = currentPage * billsPerPage;
    const indexOfFirstBill = indexOfLastBill - billsPerPage;
    const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

    const getBudgetEstimationList = async () => {
        let data = await GetAllBudgetEstimationList()
        console.log("data",data);
        
        setBudgetEstimationList(data)
        setFilteredBills(data);
    }
    useEffect(() => {
        getBudgetEstimationList()
    }, [])
    let budgetEstimationList = []
    if (budgetEstimation.length > 0) {
        budgetEstimationList = budgetEstimation
    }
    useEffect(() => {
        const lowerSearchTerm = searchTerm.toLowerCase();
        const filtered = budgetEstimation.filter(bill =>
            Object.values(bill).some((val) =>
                (val || '').toString().toLowerCase().includes(lowerSearchTerm)
            )
        );
        setFilteredBills(filtered);
        setCurrentPage(1); // Reset to page 1 on search
    }, [searchTerm, budgetEstimation]);
 return (
        <div style={{
            background: '#efecff', width: 'auto', minHeight: "92vh",
            transition: "margin-left 0.3s ease", overflowY: "auto",
            msOverflowStyle: "none", scrollbarWidth: "none", padding: 40,
            fontFamily: 'Inter, sans-serif'
        }}>
            <div style={{
                display: "grid", justifyContent: "center",
                boxShadow: "0px 0px 10px rgba(0,0,0,0.1)", borderRadius: "20px",
                backgroundColor: "white", padding: "20px 25px", maxHeight: "81vh", overflow: "auto"
            }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px", padding: "0 20px", width: "100%" }}>
                    <h5 style={{ fontWeight: "bold", color: "black", display: "flex", alignItems: "center" }}>
                        <img src={"/Budget-Estimation-Report-List-32.png"} alt="Icon" style={{ marginRight: "10px", width: 28, height: 28 }} />
                        Budget Estimation Report
                    </h5>

                    <div style={{ display: "flex", alignItems: "center", backgroundColor: "aliceblue", border: "1px solid #ccc", borderRadius: "5px", padding: "5px 10px", width: "250px" }}>
                        <img src={"/Search-32.png"} alt="Search" style={{ width: 20, height: 20, marginRight: "8px" }} />
                        <input type="text" placeholder="Search Estimation..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} style={{ border: "none", outline: "none", background: "transparent", width: "100%", fontSize: "14px" }} />
                    </div>
                </div>

                <div style={{ overflowX: "auto", width: "100%"}}>
                    <div style={{ maxHeight: "61vh", overflowY: "auto", width: "100%" }}>
                    <table style={{ backgroundColor: "white", width: "100%", minWidth: "1000px", borderCollapse: "collapse" }}>
                        <thead style={{ borderTop: 'none' }}>
                            <tr style={{ backgroundColor: "#2ea4e7", color: "white", fontSize: "13px", fontWeight: "600", textAlign: "center", whiteSpace: "nowrap" }}>
                                <th style={{ padding: '10px' }}>Project ID</th>
                                <th style={{ padding: '10px' }}>Project Name</th>
                                <th style={{ padding: '10px' }}>Financial Year</th>
                                <th style={{ padding: '10px' }}>Budget ID</th>
                                <th style={{ padding: '10px' }}>Budget Head</th>
                                <th style={{ padding: '10px' }}>Esitmate Amount</th>
                                <th style={{ padding: '10px' }}>Date</th>
                            </tr>
                        </thead>

                        {/* {currentBills?.map((budgetEstimation, idx) => (
                             <tbody  key={idx}>
                                      <tr style={{ fontSize: "13px", fontWeight: "500", textAlign: "left", whiteSpace: 'break-spaces', backgroundColor: idx % 2 === 0 ? "#f4f7fe" : "white" }}>
                                            <td style={{ padding: '10px' }}>{budgetEstimation.ProjectID}</td>
                                            <td style={{ padding: '10px' }}>{budgetEstimation.ProjectName}</td>
                                            <td style={{ padding: '10px' }}>{budgetEstimation.Year}</td>
                                            <td style={{ padding: '10px' }}>{budgetEstimation.BudgetID}</td>
                                            <td style={{ padding: '10px' }}>{budgetEstimation.BudgetHead}</td>
                                            <td style={{ padding: '10px' }}>{budgetEstimation.EsitmateAmount}</td>
                                            <td style={{ padding: '10px',whiteSpace:'nowrap' }}>
                                                <img
                                                      src={"/Time-32.png"}
                                                      style={{ marginRight:"5px",width: "15px", height: "15px"  }}
                                                />
                                                {budgetEstimation.Date?.split('T')[0].replace(' ')}
                                            </td>
                                        </tr>
                                    </tbody>
                        ))} */}
                         <tbody>
                {currentBills && currentBills.length > 0 ? (
                  currentBills.map((budgetEstimation, index) => (
                    <tr
                      key={index}
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                        textAlign: "center",
                        whiteSpace: "nowrap",
                        backgroundColor: index % 2 === 0 ? "white" : "#f4f7fe",
                      }}
                    >
                      <td style={{ padding: "10px", textAlign: "center" }}>
                        {indexOfFirstBill + index + 1}
                      </td>
                      <td style={{ padding: "10px" }}>
                        {budgetEstimation.ProjectID}
                      </td>
                      <td style={{ padding: "10px" }}>
                        {budgetEstimation.ProjectName}
                      </td>
                      <td style={{ padding: "10px" }}>
                        {budgetEstimation.Year}
                      </td>
                      <td style={{ padding: "10px" }}>
                        {budgetEstimation.BudgetID}
                      </td>
                      <td style={{ padding: "10px" }}>
                        {budgetEstimation.CRC}
                      </td>
                      <td style={{ padding: "10px" }}>
                        {budgetEstimation.BudgetHead}
                      </td>
                      <td style={{ padding: "10px" }}>
                        {budgetEstimation.ObjectCode}
                      </td>
                      <td style={{ padding: "10px" }}>
                        ₹
                        {Number(
                          budgetEstimation.EsitmateAmount || 0,
                        ).toLocaleString("en-IN")}
                      </td>
                      <td style={{ padding: "10px" }}>
                        {budgetEstimation.Date?.split("T")[0].replace(" ")}
                      </td>
                      <td style={{ padding: "10px" }}>
                        {budgetEstimation.Remark?.trim() || "-"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="11"
                      style={{
                        padding: "30px",
                        textAlign: "center",
                        color: "#777",
                        fontSize: "14px",
                        fontWeight: "600",
                      }}
                    >
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
                    </table>
                </div>
                </div>

                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "20px" }}>
                    <div>
                        <p style={{ fontSize: "17px", color: "black" }}>
                            Showing {filteredBills?.length ? Math.min(indexOfFirstBill + 1, filteredBills?.length) : 0} to {Math.min(indexOfLastBill, filteredBills?.length)} of {filteredBills?.length} entries
                        </p>
                    </div>

                    <div style={{ display: "flex" }}>
                        <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1} style={{ padding: "8px 10px", fontSize: "18px", fontWeight: "bold", width: "2rem", height: "2.5rem", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: currentPage === 1 ? "#ffffff" : "#e5f4fb", color: "#044c92", border: "1px solid #cccccc", cursor: "pointer", transition: "0.2s ease-in-out" }}>&laquo;</button>

                        <button onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))} disabled={currentPage === 1} style={{ padding: "8px 10px", fontSize: "18px", fontWeight: "bold", width: "2rem", height: "2.5rem", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: currentPage === 1 ? "#ffffff" : "#e5f4fb", color: "#044c92", border: "1px solid #cccccc", cursor: "pointer", transition: "0.2s ease-in-out" }}>&lt;</button>

                        <button style={{ padding: "8px 10px", fontSize: "18px", fontWeight: "bold", width: "2rem", height: "2.5rem", display: "flex", alignItems: "center", justifyContent: "center", background: "linear-gradient(to bottom, #044c92 , #0071bc , #022f5a )", color: "white", border: "1px solid #cccccc" }}>{currentPage}</button>

                        <button onClick={() => setCurrentPage(prev => Math.min(totalPages || 1, prev + 1))} disabled={currentPage === totalPages} style={{ padding: "8px 10px", fontSize: "18px", fontWeight: "bold", width: "2rem", height: "2.5rem", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: currentPage === totalPages ? "#ffffff" : "#e5f4fb", color: "#044c92", border: "1px solid #cccccc", cursor: "pointer", transition: "0.2s ease-in-out" }}>&gt;</button>

                        <button onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages} style={{ padding: "8px 10px", fontSize: "18px", fontWeight: "bold", width: "2rem", height: "2.5rem", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: currentPage === totalPages ? "#ffffff" : "#e5f4fb", color: "#044c92", border: "1px solid #cccccc", cursor: "pointer", transition: "0.2s ease-in-out" }}>&raquo;</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BudgetEstimationList
